import {
  ADD_FOLDER,
  ADD_FOLDER_FAILURE,
  ADD_FOLDER_SUCCESS,
  //
  UPDATE_CONTENT_FOLDERS,
  UPDATE_CONTENT_FILES,
  //
  DELETE_FOLDER,
  DELETE_FOLDER_FAILURE,
  DELETE_FOLDER_SUCCESS,
  //
  EDIT_FOLDER,
  EDIT_FOLDER_FAILURE,
  EDIT_FOLDER_SUCCESS,
  //
  FETCH_CONTENT,
  FETCH_CONTENT_FAILURE,
  FETCH_CONTENT_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  UPLOAD_FILE,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAILURE,
  //
  VALIDATE_FILE,
  VALIDATE_FILE_SUCCESS,
  VALIDATE_FILE_FAILURE,
} from "./constants";

// List
export const fetchContent = (payload) => ({
  type: FETCH_CONTENT,
  payload,
});
export const fetchContentSuccess = (payload) => ({
  type: FETCH_CONTENT_SUCCESS,
  payload,
});
export const fetchContentFailure = (payload) => ({
  type: FETCH_CONTENT_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addFolder = (payload, onAdd) => ({
  type: ADD_FOLDER,
  payload,
  onAdd,
});
export const addFolderSuccess = (payload) => ({
  type: ADD_FOLDER_SUCCESS,
  payload,
});
export const addFolderFailure = (payload) => ({
  type: ADD_FOLDER_FAILURE,
  payload,
});
// EDIT
export const editFolder = (payload, onEdit) => ({
  type: EDIT_FOLDER,
  payload,
  onEdit,
});
export const editFolderSuccess = (payload) => ({
  type: EDIT_FOLDER_SUCCESS,
  payload,
});
export const editFolderFailure = (payload) => ({
  type: EDIT_FOLDER_FAILURE,
  payload,
});
// DELETE
export const deleteFolder = (payload, onDelete) => ({
  type: DELETE_FOLDER,
  payload,
  onDelete,
});
export const deleteFolderSuccess = (payload) => ({
  type: DELETE_FOLDER_SUCCESS,
  payload,
});
export const deleteFolderFailure = (payload) => ({
  type: DELETE_FOLDER_FAILURE,
  payload,
});

// Update
export const updateContentFolders = (payload) => ({
  type: UPDATE_CONTENT_FOLDERS,
  payload,
});
export const updateContentFiles = (payload) => ({
  type: UPDATE_CONTENT_FILES,
  payload,
});

//
export const uploadFile = (payload, onUpload) => ({
  type: UPLOAD_FILE,
  payload,
  onUpload,
});
export const uploadFileSuccess = (payload) => ({
  type: UPLOAD_FILE_SUCCESS,
  payload,
});
export const uploadFileFailure = (payload) => ({
  type: UPLOAD_FILE_FAILURE,
  payload,
});

export const validateFile = (payload, onValidate) => ({
  type: VALIDATE_FILE,
  payload,
  onValidate,
});
export const validateFileSuccess = (payload) => ({
  type: VALIDATE_FILE_SUCCESS,
  payload,
});
export const validateFileFailure = (payload) => ({
  type: VALIDATE_FILE_FAILURE,
  payload,
});
